var map = {
	".": "a9sA",
	"./": "a9sA",
	"./01_connect": "3tXb",
	"./01_connect.json": "3tXb",
	"./02_data_compress": "CVyP",
	"./02_data_compress.json": "CVyP",
	"./03_heart_beat": "vR2M",
	"./03_heart_beat.json": "vR2M",
	"./04_subscribe": "UYWd",
	"./04_subscribe.json": "UYWd",
	"./05_cancel_subscribe": "2xEp",
	"./05_cancel_subscribe.json": "2xEp",
	"./index": "a9sA",
	"./index.js": "a9sA"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7aF3";


//////////////////
// WEBPACK FOOTER
// ./src/config/zh-tw/cswap/websocket/introduce ^.*$
// module id = 7aF3
// module chunks = 3